module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth"
  }, [_c('div', {
    staticClass: "login-sign"
  }, [_c('a', {
    staticClass: "sign-btn",
    on: {
      "click": function($event) {
        _vm.login = "in"
      }
    }
  }, [_vm._v("Sign In")]), _c('a', {
    staticClass: "sign-btn",
    on: {
      "click": function($event) {
        _vm.login = "up"
      }
    }
  }, [_vm._v("Sign Up")])]), (_vm.login) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        _vm.login = false
      }
    }
  }) : _vm._e(), (_vm.login) ? _c('a', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.login = false
      }
    }
  }) : _vm._e(), (_vm.login) ? _c('form', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-head"
  }, [_c('h4', {
    staticClass: "social-title"
  }, [_vm._v(_vm._s(_vm.login === 'in' ? 'Sign In' : 'Sign Up'))]), _c('div', {
    staticClass: "social-img"
  }, [_c('a', {
    staticClass: "social-link social-google",
    on: {
      "click": _vm.signInGoogle
    }
  }), _c('a', {
    staticClass: "social-link social-twitter"
  }), _c('a', {
    staticClass: "social-link social-facebook"
  })])]), _c('p', {
    staticClass: "modal-title"
  }, [_vm._v("or Be Classical")]), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-icon icon-mail"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email..."
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-icon icon-lock"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password..."
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _c('a', {
    staticClass: "modal-action",
    on: {
      "click": _vm.enter
    }
  }, [_vm._v(_vm._s(_vm.login === 'in' ? 'Enter' : 'Get Started'))])]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "note"
    }
  }, [(_vm.message.length > 0) ? _c('notification', {
    attrs: {
      "message": _vm.message
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = ""
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4f6f48fe"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 127
// module chunks = 0